import Vue from 'vue'
import AudioVisual from 'vue2-audio-visual'

Vue.use(AudioVisual)
